import { render, staticRenderFns } from "./Entrega.vue?vue&type=template&id=bfbb1900&scoped=true"
import script from "./Entrega.vue?vue&type=script&lang=js"
export * from "./Entrega.vue?vue&type=script&lang=js"
import style0 from "./Entrega.vue?vue&type=style&index=0&id=bfbb1900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb1900",
  null
  
)

export default component.exports